export const lastThirtyDaysValue = ["Últimos 30 dias", "Este mês"];
export const thisYearValue = ["Este ano", "Esse ano"];
export const selectDateValue = ["Selecionar período", "Selecionar o ano"];
